<template>
	<div class="main-wrapper">
		<title-bar title="Invoice" subtitle="Details about your purchase cart"></title-bar>
		<div class="content">
			<div class="container">
				<div class="invoice-wrapper">
					<div class="invoice-box">
						<table cellpadding="0" cellspacing="0">
							<tr class="top">
								<td colspan="2">
									<table>
										<tr>
											<td class="title">
												<img src="/static/images/logo-dark.png" style="max-width:150px;">
											</td>
											<td>
												Invoice #: 123<br>
												Created: January 1, 2015<br>
												Due: February 1, 2015
											</td>
										</tr>
									</table>
								</td>
							</tr>
							<tr class="information">
								<td colspan="2">
									<table>
										<tr>
											<td>
												Sparksuite, Inc.<br>
												12345 Sunny Road<br>
												Sunnyville, CA 12345
											</td>
											<td>
												Acme Corp.<br>
												Ethan Moore<br>
												ethan@ethan.com
											</td>
										</tr>
									</table>
								</td>
							</tr>
							<tr class="heading">
								<td>
									Payment Method
								</td>
								<td>
									Check #
								</td>
							</tr>
							<tr class="details">
								<td>
									Check
								</td>
								<td>
									1000
								</td>
							</tr>
							<tr class="heading">
								<td>
									Item
								</td>
								<td>
									Price
								</td>
							</tr>
							<tr class="item">
								<td>
									Website design
								</td>
								<td>
									$300.00
								</td>
							</tr>
							<tr class="item">
								<td>
									Hosting (3 months)
								</td>
								<td>
									$75.00
								</td>
							</tr>
							<tr class="item last">
								<td>
									Domain name (1 year)
								</td>
								<td>
									$10.00
								</td>
							</tr>
							<tr class="total">
								<td></td>
								<td>
									Total: $385.00
								</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TitleBar from 'Components/globalFrontendComponents/TitleBar';
export default {
	components: {
		TitleBar: TitleBar
	}
};
</script>
